export default __webpack_public_path__ + "app/views/delete/confirmation.html";